export default __webpack_public_path__ + "static/media/3.71fdc626.svg";